/**
 * Created by Ning Jiang on 5/18/2017.
 */

import {IReelStartSpinData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {WixxReelController} from "./WixxReelController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WixxStackedReelView} from "./WixxStackedReelView";
import {WixxParsedInitData} from "../server/data/WixxParsedInitData";
import {WixxParsedGameData} from "../server/data/WixxParsedGameData";
import {IWixxGameModeChangedData} from "../gamemode/WixxGameMode";

export class WixxStackedReelController extends WixxReelController {

    private _stackedReelFourRespinTriggered:boolean;
    private _stackedView:WixxStackedReelView;

    private _feature:string;
    private _isPlayingStackedReel:boolean;

    constructor(reelId:number) {
        super(reelId);
        this._stackedView = <WixxStackedReelView>this._reelView;
    }

    protected onInitDataParsed(data:WixxParsedInitData):void {
        super.onInitDataParsed(data);
        this.onFeatureDataParsed(data);
    }

    public onGameDataParsed(data:WixxParsedGameData):void {
        super.onGameDataParsed(data);
        this.onFeatureDataParsed(data);
    }

    protected onFeatureDataParsed(data:WixxParsedInitData | WixxParsedGameData):void {
        this._stackedReelFourRespinTriggered = data.stackedReelFourRespinTriggered;
    }

    protected onChangeMode(data:IWixxGameModeChangedData):void {
        this._feature = data.feature;
        super.onChangeMode(data);
    }

    protected setStartSpinData(data:IReelStartSpinData):void {
        super.setStartSpinData(data);

        if(data.active && this._stackedReelFourRespinTriggered) {
            this._stackedView.startStackedReel();
            this._isPlayingStackedReel = true;
        }
    }

    protected onSpinStartedCompleted():void {
        if(this._isPlayingStackedReel) {
            this._stackedView.showStackedSymbols(this._feature);
        }
        super.onSpinStartedCompleted();
    }

    protected onSpinStopAnimationCompleted():void {
        if(this._isPlayingStackedReel) {
            this._stackedView.stopStackedReel();
            this._isPlayingStackedReel = false;
        }

        super.onSpinStopAnimationCompleted();
    }

    protected getStopDelayDelta(stopSpinData:IReelStopSpinData):number{
        if(this._isPlayingStackedReel) {
            return 0
        }
        return super.getStopDelayDelta(stopSpinData);
    }
}